import {useAssertedContext} from '@pexip/media-components';

import {InfinityContext} from '../contexts/infinity.context';

export const useInfinityContext = () => useAssertedContext(InfinityContext);

/**
 * Returns the protocol client owned by the current Infinity composition.
 *
 * @example
 * const client = useInfinityClient();
 */
export const useInfinityClient = () => useInfinityContext().getClient();
